import {StripeError} from "@stripe/stripe-js";

export class StripeErrorMapper {

    public static mapAchFailureCode = (failureCode?: string | null,
                                       fallbackMessage?: string | null): string => {
        if (failureCode) {
            switch (failureCode) {
                case 'account_closed':
                    return 'This bank account is closed. Please use a different account.';
                case 'bank_account_declined':
                case 'debit_not_authorized':
                    return 'Your bank declined this payment. Please try another account.';
                case 'insufficient_funds':
                    return 'Insufficient funds in this account. Please use a different account.';
                case 'invalid_account_number':
                case 'invalid_bank_account':
                    return 'The bank account details look invalid. Please re-check and try again.';
                case 'payment_method_unactivated':
                    return 'This payment method is not activated. Please choose another method.';
                case 'payment_intent_authentication_failure':
                    return 'We could not verify this payment. Please try again.';
                case 'validation_error':
                    return fallbackMessage || 'Please check the form for missing or invalid fields.';
                default:
                    break;
            }
        }
        return fallbackMessage || "We're sorry but we were unable to process your payment. Please try again.";
    };

    public static mapStripeError = (error: StripeError): string => {
        return StripeErrorMapper.mapAchFailureCode(error.code, error.message || null);
    };
}
